function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  },
  d: "M7.297 7.297 1.565 1.565m5.797-.005c-2.315-.23-3.589-.23-5.802 0-.23 2.213-.23 3.487 0 5.802M7.297 12.792l-5.742 5.742m.005-5.807c-.23 2.315-.23 3.588 0 5.802 2.213.229 3.487.229 5.802 0M18.531 18.531l-5.674-5.674m-.13 5.672c2.315.229 3.588.229 5.802 0 .229-2.214.229-3.487 0-5.802M18.448 1.552l-5.591 5.591m5.672.219c.229-2.315.229-3.589 0-5.802-2.214-.23-3.487-.23-5.802 0",
  transform: "scale(1.5)"
}));
export default SvgLineExpand;